/**
 * Job service — browse jobs, get by ID, apply, create.
 */
import apiClient from './apiClient';

/**
 * Get all jobs with optional filters.
 */
export const getJobs = async (params = {}) => {
    const { search, job_type, sort_by, user_lat, user_lng } = params;
    const queryParams = new URLSearchParams();

    if (search) queryParams.append('search', search);
    if (job_type && job_type !== 'all') queryParams.append('job_type', job_type);
    if (sort_by) queryParams.append('sort_by', sort_by);
    if (user_lat != null) queryParams.append('user_lat', user_lat);
    if (user_lng != null) queryParams.append('user_lng', user_lng);

    return apiClient.get(`/jobs?${queryParams.toString()}`);
};

/**
 * Get single job by ID.
 */
export const getJobById = async (id) => {
    return apiClient.get(`/jobs/${id}`);
};

/**
 * Apply for a job (public).
 */
export const applyJob = async (jobId, applicationData) => {
    return apiClient.post(`/jobs/${jobId}/apply`, applicationData);
};

/**
 * Create a new job posting (organization, requires auth).
 */
export const createJob = async (jobData) => {
    return apiClient.post('/jobs/create', jobData);
};

/**
 * Get my organization's jobs (requires auth).
 */
export const getMyJobs = async () => {
    return apiClient.get('/jobs/my');
};

/**
 * Update a job posting (requires auth).
 */
export const updateJob = async (jobId, jobData) => {
    return apiClient.put(`/jobs/${jobId}`, jobData);
};

/**
 * Mark job as fulfilled.
 */
export const markJobFulfilled = async (jobId, remarks = '') => {
    const params = remarks ? `?remarks=${encodeURIComponent(remarks)}` : '';
    return apiClient.post(`/jobs/${jobId}/mark-fulfilled${params}`);
};
